import { createAction, createReducer } from '@reduxjs/toolkit'
import { apiCallBegan } from 'store/apiCalls'
import { toast } from 'react-toastify'

// ACTIONS
const updateUserRequested = createAction('updateUser/requested')
const updateUserRequestFailed = createAction('updateUser/requestFailed')
const updateUserReceived = createAction('updateUser/received')
const updateUserClean = createAction('updateUser/clean')

// REDUCER
const initialState = {
  loading: false,
  success: false
}

const updateUserReducer = createReducer(initialState, {
  [updateUserRequested.type]: (state) => {
    state.loading = true
    state.success = false
  },
  [updateUserReceived.type]: (state) => {
    state.loading = false
    state.success = true
  },
  [updateUserRequestFailed.type]: (state, action) => {
    state.loading = false
    state.success = false
    toast.error(action.payload.message)
  },
  [updateUserClean.type]: () => initialState
})

export default updateUserReducer

// PUBLIC ACTIONS
export const updateProfile = (data) =>
  apiCallBegan({
    url: '/user',
    method: 'put',
    data: { user: data },
    onStart: updateUserRequested.type,
    onSuccess: updateUserReceived.type,
    onError: updateUserRequestFailed.type
  })

export const cleanUpdateUser = () => (dispatch) => {
  dispatch(updateUserClean())
}
